import { AuthGuard } from "@redotech/redo-customer-portal-app/contexts/auth";
import { Outlet, RouteObject } from "react-router-dom";

export const omsRoutes: RouteObject[] = [
  {
    element: (
      <AuthGuard>
        <Outlet />
      </AuthGuard>
    ),
    children: [
      {
        path: "address-edit/:fulfillmentGroupId",
        lazy: async () => {
          const { OmsAddressEditPage } = await import(
            "@redotech/redo-customer-portal-app/portal-four/oms/address-edit-ui"
          );
          return { Component: OmsAddressEditPage };
        },
      },
    ],
  },
];
